import PropTypes from 'prop-types'
import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Legend } from '../../../../common/chart/legend'
import { PieChartContainer } from '../../../../common/chart/pieChart'
import { getUnique } from '../../../../helpers/common'
import { formatText, formatVal } from '../../../../helpers/value'
import { TitlePieChart } from './TitlePieChart'

export const PieChartComponent = ({ data, title, onPieClick, activeIndex }) => {
  const chartId = useRef(getUnique())

  const locale = useSelector((state) => state.i18n.locale)

  const formatData = data.map((item) => {
    return {
      ...item,
      name: formatText(item.name),
    }
  })

  return (
    <div>
      <TitlePieChart title={title} isI18n />
      <div className="mt1 dFlex alignItemsCenter gap2">
        <PieChartContainer
          chartId={chartId.current}
          innerRadius={30}
          width={150}
          height={150}
          data={formatData}
          isLabelActive={false}
          onPieClick={onPieClick}
          formatValueTooltip={(val) => formatVal(val * 100, locale) + '%'}
          defaultActiveIndex={activeIndex}
        />
        <Legend
          chartId={chartId.current}
          className="flexColumn"
          items={formatData.map((item, index) => ({
            isI18n: item.isI18n,
            title: item.name,
            color: item.color,
            pieIndex: index,
          }))}
        />
      </div>
    </div>
  )
}

PieChartComponent.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  onPieClick: PropTypes.func,
}
